<div class="reg-overlay" (click)="closePopup()">

  <div class="reg-popup" (click)="$event.stopPropagation()">

    <div id="vehicle-form-wrapper"
         fusePerfectScrollbar
         [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}"
         [ngClass]="{'is-make': !vehicleInfo}">
    
        <div id="vehicle-form"
             *ngIf="!vehicleInfo"
             style="margin-top: 2%;width: 100%;">

            <form [class.loading]="loading"
                  name="vehicleForm"
                  [formGroup]="vehicleForm"
                  (ngSubmit)="onSubmit()"
                  novalidate>

                <div class="enter">
                    <mat-label for="regNo">Enter your car number</mat-label>
                </div>
                    <button class="close-btn" (click)="closePopup()"><mat-icon>close</mat-icon></button>
                <mat-form-field appearance="outline" style="font-size: larger;">
                    <div style="display: flex; align-items: center;" class="left-section-main">
                        <div class="left-section">
                            <img src="../../../../assets/images/home-page-reg-number/Group 16(1).png"
                                 alt="Car"
                                 width="18"
                                 height="10">
                            <span class="ind">IND</span>
                        </div>

                        <div style="border-right: 1px solid #dddddd;height: 20px;width: 2px;margin-top: 4px;"></div>

                        <div class="registration-number">
                            <input id="regNo"
                                   matInput
                                   formControlName="regNo"
                                   autocomplete="off"
                                   placeholder="KA 01 MY97**"
                                   maxlength="13"
                                   style="font-weight: 600; width: 98%;">
                        </div>
                    </div>

                    <mat-error *ngIf=" submitted && vehicleForm.get('regNo').hasError('required')">
                            Registration Number is required
                    </mat-error>

                </mat-form-field>

                <button mat-raised-button
                        
                        class="submit-button"
                        aria-label="VEHICLE"
                        [disabled]="vehicleForm.invalid">
                    FIND MY CAR
                </button>
                <div class="separator" [ngClass]="{'separatorMobile': isMobile}">
                    <span class="text">Or</span>
                </div>

                <h4 class="text-center"
                    [ngClass]="{'text-centerMobile': isMobile}"
                    (click)="goToMake()">
                    Enter car details manually
                </h4>
            </form>

        </div>

        <div [attr.id]="isMobile ? 'vehicle-infoMobile' : 'vehicle-info'"
            *ngIf="vehicleInfo"
            #popupSection>

            <div class="logo-container">
                <img src="../../../../assets/images/logos/mobile_autoverse_logo.svg" alt="Autoverse Logo">
                <p><strong>AUTOVERSE</strong></p>
                <img src="../../../../assets/images/share.png"
                    alt="Share"
                    (click)="shareDetails()"
                    style="left: 28%;position: relative; cursor: pointer;">
            </div>

            <p class="registration-number">{{vehicleData?.registrationNumber}}</p>

            <div class="vehicle-details-row">
                <div class="left"><mat-icon>check_circle</mat-icon>Make</div>
                <div class="right">{{vehicleData?.make}}</div>
            </div>

            <div class="vehicle-details-row">
                <div class="left"><mat-icon>check_circle</mat-icon>Model</div>
                <div class="right">{{vehicleData?.model}}</div>
            </div>

            <div class="vehicle-details-row">
                <div class="left"><mat-icon>check_circle</mat-icon>Variant</div>
                <div class="right">{{vehicleData?.variant}}</div>
            </div>

            <div class="vehicle-details-row">
                <div class="left"><mat-icon>check_circle</mat-icon>MFG Year</div>
                <div class="right">{{vehicleData?.year}}</div>
            </div>

            <div class="vehicle-details-row">
                <div class="left"><mat-icon>check_circle</mat-icon>Fuel</div>
                <div class="right">{{vehicleData?.fuel}}</div>
            </div>

            <div class="vehicle-details-row">
                <div class="left"><mat-icon>check_circle</mat-icon>VIN</div>
                <div class="right">{{vehicleData?.vin}}</div>
            </div>

            <div class="vehicle-details-row" *ngIf="vehicleData?.generation">
                <div class="left"><mat-icon>check_circle</mat-icon>Generation</div>
                <div class="right">{{vehicleData?.generation}}</div>
            </div>

            <div class="vehicle-details-row" *ngIf="vehicleData?.vehicleType">
                <div class="left"><mat-icon>check_circle</mat-icon>Vehicle Type</div>
                <div class="right">{{vehicleData?.vehicleType}}</div>
            </div>

            <button mat-raised-button
                    color="accent"
                    class="confirm-btn"
                    (click)="confirmCar()">
                Confirm
            </button>

            <button mat-raised-button
                    color="accent"
                    class="change-car-button"
                    (click)="changeCar()">
                Change Car
            </button>

        </div>

    </div>

  </div>

</div>

